  import React from "react";
  import { Button } from "react-bootstrap";

  
  /**
   * Renders a button component with an optional icon.
   *
   * @component
   * @param {Object} props - The component props.
   * @param {string} props.btnTitle - The title of the button.
   * @param {function} props.cbFunc - The callback function to be called when the button is clicked.
   * @param {any} props.data - The data to be passed to the callback function.
   * @param {React.Component} props.Icon - The icon component to be displayed before the button title.
   * @param {Object} [props.ButtonStyle] - The custom style object for the button.
   * @param {Object} [props.IconStyle] - The custom style object for the icon.
   * @param {boolean} [props.isLoading=false] - Specifies whether the button is in a loading state.
   * @returns {JSX.Element} The rendered ButtonWithIcon component.
   */
  const ButtonWithIcon = ({ btnTitle, cbFunc, data, Icon, ButtonStyle, IconStyle, isLoading = false }) => {
    return (
      <div style={{ paddingRight: "20px" }}>
        <Button
          style={
            ButtonStyle
              ? ButtonStyle
              : {
                  backgroundColor: "#0D6EFD",
                  color: "white"
                }
          }
          onClick={() => {
            if (!isLoading) {
              cbFunc(data);
            }
          }}
          disabled={isLoading}
        >
          {isLoading && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <div
                style={{
                  height: "15px",
                  width: "15px",
                  marginRight: "10px",
                  transform: "scale(0.5)",
                  border: "2px solid #f3f3f3",
                  borderTopColor: "transparent",
                  borderRightColor: "transparent",
                  animation: "spin 1s linear infinite",
                  borderRadius: "50%"
                }}
              />
              Loading
            </div>
          )}
          {!isLoading && (
            <>
              {Icon && (
                <Icon
                  style={{
                    marginRight: "5px",
                    fontSize: "20px",
                    ...IconStyle
                  }}
                />
              )}
              {btnTitle}
            </>
          )}
        </Button>
      </div>
    );
  };

  export default ButtonWithIcon;